import React from 'react';
import { Navigate } from 'react-router-dom';
import { UserAuth } from '../../context/AuthContext';

const ProtectedRoute = ({ children }) => {

    const { user, loading } = UserAuth();

    if (loading) {
        return null;
    }

    if (!user) {
        return <Navigate to="/signin" />;
    }

    return children;

};

export default ProtectedRoute;
